<template>
    <NuxtLayout name="casino">
        <div class="triple-game">
            <ClientOnly fallback-tag="span">
                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
                    <GameSettingsButtonLiveChat
                        v-if="userStore.isLoggedIn"
                        v-model="isOpenLiveChat"
                    />
                    <GameSettingsButtonAnimate v-model="settingStore.animation" />
                    <GameSettingsButtonFairness v-model="isOpenFairness" />
                    <GameSettingsButtonRule v-model="isOpenRule" name="triple" />
                    <GameSettingsButtonVocie
                        v-model="settingStore.inhouseGames.sound.on"
                        v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                        :saveAfterChange="true"
                    />
                </GameSettingsDiceTabsWrapper>
            </ClientOnly>
            <!-- 展示区 -->
            <div class="game-container">
                <!-- 左侧结果对比区域 -->
                <ClientOnly>
                    <ResultCoef :data="resultLeft[riskModel]" :rollNumber="rollNumber" />
                </ClientOnly>
                <!-- 中间选择区域 -->
                <ClientOnly>
                    <GameContent
                        :isAnimation="isAnimation"
                        :randomSeed="randomSeed"
                        :tableArray="tableArray"
                        :isSubmiting="oForm.isSubmiting"
                        @changeSelectStatusFun="changeSelectStatusFun"
                        :class="showWarning ? 'arrow-box' : ''"
                    />
                </ClientOnly>
                <!-- 右侧结果对比区域 -->
                <ClientOnly>
                    <ResultCoef :data="resultRight[riskModel]" :rollNumber="rollNumber" />
                </ClientOnly>
            </div>
            <!-- 投注选项区域 -->
            <div class="q-mt-md buttons-operation">
                <div class="q-mt-md buttons-row">
                    <ClientOnly>
                        <div class="buttons-col">
                            <DropDown
                                v-if="dropDownRiskOptions.length > 0"
                                v-model="riskModel"
                                :options="dropDownRiskOptions"
                                @update:model-value="(value) => handleUpdateRisk(value)"
                                class="h-[48px]"
                                :disabled="oForm.isSubmiting"
                            >
                                <template #prevIcon>
                                    <span class="text-sm font-semibold text-[#55657e]">
                                        {{ $t('risk') }}
                                    </span>
                                </template>
                            </DropDown>
                        </div>
                    </ClientOnly>
                    <!-- 选项 -->
                    <ClientOnly>
                        <GameControls
                            :riskModel="riskModel"
                            :btnDisabled="btnDisabled"
                            :isSubmiting="oForm.isSubmiting"
                            @handleUpdateRisk="handleUpdateRisk"
                            @handleAutoPick="handleAutoPick"
                            @handleClearTable="handleClearTable"
                        />
                    </ClientOnly>
                </div>
                <ClientOnly>
                    <div>
                        <CasinoBetOptionSection
                            v-if="autoBetToolKit || betTookit"
                            :betTookit="betTookit && betTookit"
                            :auto-bet-tool-kit="autoBetToolKit && autoBetToolKit"
                            v-model:bet-amount-modal-value="oForm.amount"
                            v-model:is-submiting="oForm.isSubmiting"
                            :is-auto="gameStore?.triple.auto.default"
                            :bet-submit="betSubmit"
                            class="game-body"
                            :normalBtnDisabled="pickSet.length < 3 && !btnDisabled"
                            :autoBtnDisabled="pickSet.length < 3 && !btnDisabled"
                            @change-mode="toChangeMode"
                        >
                            <template #button-mask v-if="pickSet?.length !== 3">
                                <div class="button-mask" @click="handleClickMask"></div>
                            </template>
                        </CasinoBetOptionSection>
                    </div>
                </ClientOnly>
            </div>
            <!-- 赢分后显示下注结果 -->
            <TripleResult :showResult="showResult" :result="betResult" />
            <!-- 自动 -->
            <ClientOnly>
                <div class="auto-section">
                    <CasinoAutoSection
                        :is-submiting="oForm.isSubmiting"
                        :is-auto="gameStore.triple.auto.default"
                        :ref="(el) => (oAutoDialog = el)"
                        v-model:amount="oForm.amount"
                    />
                </div>
            </ClientOnly>
        </div>
    </NuxtLayout>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
// components
import TripleResult from './_components/result/index.vue';
import ResultCoef from './_components/resultCoef/index.vue';
import GameContent from './_components/gameContent/index.vue';
import GameControls from './_components/gameControls/index.vue';
// stores & sockets
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useGameSocket } from '@/socket/game/index';
// functions
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
// mock & data
import { resultLeft, resultRight, tableArray } from './data/index';
import lose from '@/assets/mp3/losing.mp3';
import win from '@/assets/mp3/limbo/limbo_win.mp3';
import selectTriple from '@/assets/mp3/triple/select-triple.mp3';
import selectBGM from '@/assets/mp3/game_general_bgm.mp3';
import {showTips4BadAmountIfNeeded} from '@/common/js/betHelper';

export default defineComponent({
    name: 'tripleGame',
    components: {
        TripleResult,
        ResultCoef,
        GameContent,
        GameControls,
    },
    props: [],
    data() {
        const { t: $tFn } = useNuxtApp().$i18n;
        return {
            riskModel: 'Medium',
            dropDownRiskOptions: [
                {
                    name: $tFn('commonInfo.riskLow'),
                    value: 'Low',
                },
                {
                    name: $tFn('commonInfo.riskMedium'),
                    value: 'Medium',
                },
                {
                    name: $tFn('commonInfo.riskHigh'),
                    value: 'High',
                },
            ],
            tableArray,
            pickSet: [], // 已选择的方格
            randomSeed: [],
            resultLeft,
            resultRight,
            isOpenLiveChat: false, // 右侧统计
            isOpenFairness: false, // 公平性弹框
            isOpenRule: false, // 规则弹框
            gameStore: useSettingsStore().game,
            settingStore: useSettingsStore(),
            userStore: useUserStore(),
            joinStore: useJoinStateStore(),
            oForm: {
                amount: 0,
                isSubmiting: false,
            },
            autoBetToolKit: null,
            betTookit: null,
            rollNumber: [],
            betResult: null, // 下注结果数据
            showResult: false, // 是否显示下注结果提示弹框
            musicControler: null,
            soundsOption: {
                bg: {
                    src: selectBGM,
                    loop: true,
                    isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
                },
                win: {
                    src: win,
                },
                lose: {
                    src: lose,
                },
                selectTriple: {
                    src: selectTriple,
                },
            },
            btnDisabled: false,
            resultTimer: null,
            oAutoDialog: null,
            showWarning: false,
        };
    },
    computed: {
        isAnimation() {
            return this.settingStore.animation;
        },
    },
    watch: {
        // 监听自动模式切换
        'settingStore.game.triple.auto.default': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.randomSeed = [];
                    this.pickSet = [];
                    this.rollNumber = [];
                    this.tableArray = this.tableArray.map((item) => ({
                        ...item,
                        status: '',
                    }));
                }
            },
        },
        // 监听音效开关 是否播放背景音乐
        'settingStore.inhouseGames.sound.on': {
            handler(newVal) {
                if (newVal && !this.musicControler) {
                    // 音效初始化
                    this.musicControler = new MusicControler(this.soundsOption);
                }
            },
            deep:true,
            immediate: true,
        },
        'oForm.amount': {
            handler(newVal) {
                 // 金额变化调取非理性提示
                this.showTipsMaxWin()
            },
            immediate: true,
        },
       
    },
    mounted() {
        this.autoBetToolKit = useAutoBetToolKit(this.oForm, this.betSubmit);
        this.betTookit = useBettingToolkit(this.oForm);
        this.pickSet = [];
        onUnmounted(() => {
            this.handleClearTable();
            this.musicControler?.toDestory();
        });
    },
    methods: {
        /**
         * 下注
         */
        async betSubmit() {
            const { EMIT_TRIPLE_BET } = useGameSocket();
            if (this.pickSet.length < 3) return;
            if (this.showResult) {
                this.showResult = false;
            }
            const isAuto = Boolean(this.gameStore?.triple.auto.default); 
            if (!isAuto) {
                this.joinStore.gameRunning = true;
            }
            this.btnDisabled = true;
            if (this.settingStore.animation) {
                this.randomSeed = [];
            }
            let params = {
                amount: this.oForm.amount.beFixed(2),
                frontID: new Date().getTime(),
                risk: this.riskModel.toLocaleLowerCase(),
                selected: this.pickSet,
                isFast: !this.settingStore.animation,
            };
            // if (import.meta.env.DEV_MODE && isAuto && Math.random() <= 0.3){ 
            //     params.amount = '0'; 
            // }
            try {
                const ts = this.userStore.queueStart(); // 防止余额立即变化
                this.betResult = await EMIT_TRIPLE_BET(params);
                if (!this.betResult?.code && !this.betResult?.error) {
                    // 赢分
                    if (this.betResult?.winAmount) {
                        this.showResult = true;
                        this.musicControler?.oAudio.win.toPlay();
                    } else {
                        this.musicControler?.oAudio.lose.toPlay();
                    }
                    this.randomSeed = this.betResult.randomSeed.split('_')[0].split(',');
                    this.rollNumber = this.betResult.roll_number;
                    await Sleep(700);
                    this.joinStore.showDateInQueue(); // 插入游戏结果并播放动画
                    this.userStore.queueForward(ts); // 显示余额变化
                    this.btnDisabled = false;
                    if (!isAuto) {
                        this.joinStore.gameRunning = false;
                    }
                    if (this.resultTimer) {
                        clearTimeout(this.resultTimer);
                    }
                    if (this.showResult) {
                        this.resultTimer = setTimeout(
                            () => {
                                this.showResult = false;
                            },
                            isAuto ? 1000 : 2000,
                        );
                    }
                    return {
                        amount: this.oForm.amount.beFixed(2),
                        winAmount: this.betResult.winAmount,
                    };
                } else {
                    // 下注异常
                    this.userStore.queueDelete(ts);
                    isAuto || showNegativeNotify(this.betResult.error);
                    this.joinStore.gameRunning = false;
                    return this.betResult; 
                }
            } catch (error) {
                this.userStore.queueDelete(ts);
                console.log(error, 'catch');
                this.joinStore.gameRunning = false;
            }
        },
        /**
         * 随机选择
         */
        handleAutoPick() {
            console.log(
                'this.musicControler?.oAudio.selectTriple',
                this.musicControler?.oAudio.selectTriple.duration(),
            );
            // if (!this.musicControler?.oAudio.selectTriple.playing()){
            //     this.musicControler?.oAudio.selectTriple.toPlay();
            // }
            // 添加延时，等音效播放完毕后才可以再点击
            this.btnDisabled = true;
            this.musicControler?.oAudio.selectTriple.toPlay();
            const delay = this.musicControler?.oAudio?.selectTriple?.duration() * 1000 || 300;
            setTimeout(() => {
                this.btnDisabled = false;
            }, delay);
            this.handleClearTable();
            if (this.showResult) {
                this.showResult = false;
            }
            // 3 次
            let arr = [];
            for (let i = 0; i < 3; i++) {
                let random = Math.floor(Math.random() * 36);
                while (arr.includes(random)) {
                    random = Math.floor(Math.random() * 36);
                }

                this.tableArray[random].status = 'selected';
                arr.push(random);
            }
            this.pickSet = arr;
        },
        /**
         * 清空已选择
         */
        handleClearTable() {
            this.tableArray.forEach((el) => {
                el.status = '';
            });
            this.pickSet = [];
            this.randomSeed = [];
            this.rollNumber = [];
        },
        /**
         * 点击选择
         */
        changeSelectStatusFun(k: number) {
            if (!this.musicControler?.oAudio.selectTriple.playing()) {
                let status = this.tableArray[k].status;
                this.musicControler?.oAudio.selectTriple.toPlay();
                if (this.randomSeed.length) {
                    this.tableArray = this.tableArray.map((item) => ({
                        ...item,
                        status: '',
                    }));
                    this.randomSeed = [];
                    this.pickSet = [];
                    this.rollNumber = [];
                    this.showResult = false;
                    return;
                }
                if (status) {
                    this.tableArray[k].status = '';
                    this.pickSet.splice(this.pickSet.indexOf(k), 1);
                } else {
                    if (this.pickSet.length >= 3) return;
                    this.tableArray[k].status = 'selected';
                    this.pickSet.push(k);
                }
            }
        },
        /**
         * 切换风险等级,并重置数据、状态
         */
        handleUpdateRisk(value: string) {
            
            this.riskModel = value;
            this.randomSeed = [];
            this.pickSet = [];
            this.rollNumber = [];
            this.tableArray = this.tableArray.map((item) => ({
                ...item,
                status: '',
            }));
            // 切换难度调取非理性提示
            this.showTipsMaxWin()
        },
        // ↓ 自动模式输入面板“窗口化改造” 添加的变量与方法：
        toChangeMode(isAuto) {
            // ↓按各个游戏的实际情况设定
            this.settingStore.game.triple.auto.default = !!isAuto;
            if (isAuto) {
                this.oAutoDialog.switchAutoDialogVisible(true);
            }
        },
        async handleClickMask() {
            if (this.showWarning) return;
            if (this.pickSet.length !== 3) {
                this.showWarning = true;
                await Sleep(800);
                this.showWarning = false;
            }
        },
        showTipsMaxWin(){
            // 获取当前最大倍数
            const [{odd}] = resultRight[this.riskModel]?.slice(-1)
            const tripleMaxWin = Number(this.oForm.amount.beFixed(2)) * Number(odd)
            showTips4BadAmountIfNeeded(tripleMaxWin)
        }
    },
});
</script>
<style lang='scss' scoped>
.triple-game {
    width: 100%;
    height: 100%;
    position: relative;

    @media (max-width: 768px) {
        padding: 2px 0px;
    }

    .button-operation {
        width: 100%;
        max-width: 650px;
        margin: 0 auto;

        .button-settings {
            cursor: pointer;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 12px;
            margin-top: 2px;
            width: 100%;

            & > :deep(div) {
                flex: none;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        @media (max-width: 1000px) {
            .button-settings {
                justify-content: flex-start;

                & > :deep(div) {
                    flex: 1;
                }
            }
        }
    }

    .game-container {
        border-radius: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        position: relative;
        &::before {
            background: #191e28 url('@/assets/imgs/triple/triple-bg.webp') no-repeat 0 0;
            background-size: 100% 100%;
            content: '';
            display: block;
            height: 100%;
            left: 0;
            pointer-events: none;
            position: absolute;
            top: 0;
            user-select: none;
            z-index: 0;
            border-radius: 10px;
            width: 100%;
            transition: background-image 0.5s ease;
            will-change: background-image;
            @media (max-width: 767px) {
                background-size: cover;
                border-radius: 0;
                left: -15px;
                width: calc(100% + 30px);
            }
        }
        :deep(.result-coef-item) {
            align-items: center;
            border: 2px solid #283753;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            padding: 4px;
            width: 56px;
            .item-imgs {
                align-items: center;
                display: flex;
                margin-bottom: 7px;
                @media (max-width: 767px) {
                    margin-bottom: 4px;
                }
                img {
                    width: 33%;
                    @media (max-width: 767px) {
                        width: 14px;
                    }
                    @media (max-width: 375px) {
                        width: 13px;
                    }
                    &:not(:last-child) {
                        margin-right: 1px;
                    }
                }
            }
            .item-value {
                font-size: 14px;
                font-weight: 500;
                line-height: 1;
                opacity: 0.5;
                white-space: nowrap;
            }
        }
        :deep(.normal) {
            opacity: 0.5;
        }
        :deep(.win) {
            border-color: #4e7cff;
        }
    }
    .auto-section {
        @media (max-width: 1100px) {
            margin-bottom: 0;
            margin-top: 15px;
        }
        @media (max-width: 576px) {
            align-items: center;
            flex-direction: column;
        }
    }
}
.buttons-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 576px) {
        margin-bottom: 10px;
    }
    .buttons-col {
        width: calc(50% - 10px);
        @media (max-width: 576px) {
            width: calc(50% - 4px);
        }
        &:last-child {
            display: flex;
            justify-content: space-between;
            align-items: center;
            :deep(button) {
                width: calc(50% - 4px);
                font-size: 14px;
                border: 1px solid transparent;
                border-radius: 7px;
                color: #fff;
                font-style: normal;
                font-weight: 600;
                line-height: 1.4;
                position: relative;
                text-align: center;
                text-decoration: none;
                transition: all 0.3s;
                user-select: none;
                white-space: nowrap;
                @media (max-width: 500px) {
                    align-items: center;
                    display: flex;
                    font-size: 11px;
                    justify-content: center;
                    line-height: 11px;
                    overflow-wrap: break-word;
                    white-space: normal;
                    word-wrap: break-word;
                    -webkit-hyphens: auto;
                    hyphens: auto;
                }
            }
            :deep(.btn-yellow) {
                display: -webkit-box;
                height: 48px;
                padding: 4px;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                color: #000;
                background-color: #ffb636;
                border-color: #ffb636;
                &:hover {
                    box-shadow: 0 14px 20px #ffbc004d;
                    background-color: #ffc31a;
                }
            }
            :deep(.btn-grey) {
                display: -webkit-box;
                height: 48px;
                padding: 4px;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                background-color: #1b2233;
                border-color: #1b2233;
                &:hover {
                    box-shadow: 0 14px 20px #1b22334d;
                    background-color: #242d44;
                }
            }
        }
    }
}
</style>